import React from "react";
import { useTranslation } from "react-i18next";
import { PaymentField } from "./PaymentField";
import { ApiToggle } from "./ApiToggle";
import { PaylineConfig } from "./types";

type PaylineFormProps = {
    config: PaylineConfig;
    onChange: (update: Partial<PaylineConfig>) => void;
};

export function PaylineForm({ config, onChange }: PaylineFormProps) {
    const { t } = useTranslation();
    return (
        <div data-testid="payline-form" className="payment-form__clz">
            <ApiToggle
                label={t("API")}
                value={config.api}
                onChange={(api) => onChange({ api })}
            />
            <PaymentField
                testId="payline-contract"
                label={t("Contract")}
                value={config.contrat}
                onChange={(contrat) =>
                    onChange({
                        contrat: contrat
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, ""),
                    })
                }
            />
            <PaymentField
                testId="payline-reference"
                label={t("Reference")}
                value={config.reference}
                onChange={(reference) => onChange({ reference })}
            />
        </div>
    );
}
